export enum PromoHeadingColor {
  BERRY = 'berry',
  DARK_MINT = 'dark-mint',
  MIDNIGHT_BLUE = 'midnight-blue',
  PURPLE = 'purple',
  NEUTRAL = 'neutral'
}
